import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { isUndefined, get, truncate, keyBy } from 'lodash'
import { defaultMemoize } from 'reselect'
import qs from 'query-string'
import Dotdotdot from './MagikDotDotDot'
import { Link } from 'react-router-dom'
import FixedImg from './FixedImg'
import WantedHeart from './WantedHeart'
import { AFFIDABILITA_ICON_NAME } from '../styles/icons'
import Card, { CardContent, CardActions } from 'material-ui-next/Card'
import { withStyles } from 'material-ui-next/styles'
import Typography from 'material-ui-next/Typography'
import Chip from 'material-ui-next/Chip'
import Icon from 'material-ui-next/Icon'
import { getFilterAttributesByCategory } from '../utils'
import { getCategory } from '../selectors'

const styles = theme => ({
  containerStyle: {
    height: 430,
  },
  containerStyleClickable: {
    cursor: 'pointer',
    height: 430,
  },
  flexContainer: {
    display: 'flex',
    height: 30,
  },
  ownContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 5,
    height: 30,
  },
  titleStyle: {
    fontSize: 18,
    fontWeight: 'bold',
    lineHeight: '20px',
    paddingBottom: 0,
    marginBottom: 0,
    color: theme.swapick.colors.positive,
  },
  cardTextStyle: {
    paddingTop: 0,
    paddingBottom: 0,
    height: 80,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  categoryLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    color: theme.swapick.colors.labelgrey,
    marginBottom: 10,
    cursor: 'pointer',
    '&:hover': {
      color: theme.swapick.colors.darkpositive,
    },
  },
  genereSeparator: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 10,
    color: theme.swapick.colors.labelgrey,
  },
  cardOwner: {
    width: '100%',
    borderTop: '0.05px solid #E5E5E5',
    fontSize: '10px',
    paddingLeft: '16px',
    height: '55px',
  },
  place: {
    display: 'inline-flex',
    height: '20px',
    fontWeight: 600,
    marginBottom: 8,
  },
  tradesInfo: {
    display: 'inline',
    position: 'relative',
    top: '-5px',
    fontSize: 11,
    right: '-0.6px',
  },
  chip: {
    height: 22,
    fontSize: 12,
    border: '1px solid',
    borderColor: theme.swapick.colors.positive,
    color: theme.swapick.colors.positive,
    backgroundColor: 'transparent',
  },
  userLinkStyle: {
    color: theme.swapick.colors.positive,
    fontWeight: 'bold',
    '&:visited': {
      color: `${theme.swapick.colors.positive}!important`,
    },
    '&:link': {
      color: `${theme.swapick.colors.positive}!important`,
    },
    '&:hover': {
      color: `${theme.swapick.colors.lightblack}!important`,
    },
    '&:active': {
      color: `${theme.swapick.colors.lightblack}!important`,
    },
  },
  iconStyles: {
    marginRight: 0,
    fontSize: 18,
  },
  iconStylesRel: {
    marginRight: 0,
    fontSize: 18,
    position: 'relative',
    top: '5px',
  },
  noPaddingTopBottom: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  centerIconContainer: {
    position: 'absolute',
    left: '50%',
    paddingTop: 5,
  },
  rightIconContainer: {
    marginLeft: 'auto',
    paddingRight: 16,
    paddingTop: 5,
  },
  placeText: {
    position: 'relative',
    top: -4,
  },
  attributeLink: {
    fontWeight: '500',
    color: `${theme.swapick.colors.positive}`,
    '&:hover': {
      color: `${theme.swapick.colors.secondary}`,
    },
    '&:visited': {
      color: `${theme.swapick.colors.positive}`,
    },
    '&:active': {
      color: `${theme.swapick.colors.secondary}`,
    },
  },
})

const stopClick = e => e.stopPropagation()

class ObjectCard extends PureComponent {
  handleClick = () => {
    this.props.onClick(this.props.item)
  }

  // Make attribute link
  attributeLink = attribute => {
    if (attribute && this.props.item) {
      const { item } = this.props
      return `/category/${item.categoria.slug}?${qs.stringify({
        attributi: JSON.stringify({
          [attribute.chiave]: attribute.valore,
        }),
      })}`
    }
    return null
  }

  isFilterAttribute = attribute => {
    const { filterAttributes } = this.props
    if (filterAttributes && attribute) {
      return !isUndefined(filterAttributes[attribute.chiave])
    }
    return false
  }

  render() {
    const {
      item,
      iWant,
      iWantNot,
      wantedLoading,
      onClick,
      classes,
      withAttributeLinks = false,
    } = this.props

    const generes = item.genere
      ? item.genere.split(',').map(genere => genere.trim())
      : []

    return (
      <Card
        className={
          onClick ? classes.containerStyleClickable : classes.containerStyle
        }
        onClick={onClick ? this.handleClick : undefined}>
        <div style={{ height: 85 }}>
          <CardContent>
            <Dotdotdot clamp={2}>
              <Typography type="headline" className={classes.titleStyle}>
                {item.titolo}
              </Typography>
            </Dotdotdot>
            <Link onClick={stopClick} to={`/category/${item.categoria.slug}`}>
              <label className={classes.categoryLabel}>
                {get(item, 'categoria.nome')}
              </label>
            </Link>
            {generes.length > 0 && (
              <span className={classes.genereSeparator}>{' > '}</span>
            )}
            {generes.length > 0 &&
              generes.map((genere, i) => (
                <span key={genere}>
                  <Link
                    onClick={stopClick}
                    to={`/category/${item.categoria.slug}?genere=${genere}`}>
                    <label className={classes.categoryLabel}>{genere}</label>
                  </Link>
                  {i < generes.length - 1 && (
                    <span className={classes.categoryLabel}>{', '}</span>
                  )}
                </span>
              ))}
          </CardContent>
        </div>
        <FixedImg src={item.immagine} height={200} resolution="small" />

        <CardContent classes={{ root: classes.noPaddingTopBottom }}>
          <Typography className={classes.cardTextStyle} type="subheading">
            <div style={{ height: 40, marginTop: 5 }}>
              {withAttributeLinks &&
              get(item, 'attributi[0]') &&
              this.isFilterAttribute(get(item, 'attributi[0]')) ? (
                <Link
                  onClick={stopClick}
                  to={this.attributeLink(get(item, 'attributi[0]'))}>
                  <Dotdotdot clamp={1} className={classes.attributeLink}>
                    {get(item, 'attributi[0].valore', '')}
                  </Dotdotdot>
                </Link>
              ) : (
                <Dotdotdot clamp={1}>
                  {get(item, 'attributi[0].valore', '')}
                </Dotdotdot>
              )}
              {withAttributeLinks &&
              get(item, 'attributi[1]') &&
              this.isFilterAttribute(get(item, 'attributi[1]')) ? (
                <Link
                  onClick={stopClick}
                  to={this.attributeLink(get(item, 'attributi[1]'))}>
                  <Dotdotdot clamp={1} className={classes.attributeLink}>
                    {get(item, 'attributi[1].valore', '')}
                  </Dotdotdot>
                </Link>
              ) : (
                <Dotdotdot clamp={1}>
                  {get(item, 'attributi[1].valore', '')}
                </Dotdotdot>
              )}
              {!get(item, 'attributi[1].valore') && <span> &nbsp;</span>}
            </div>
            <div className={classes.ownContainer}>
              {item.posseduto_da &&
                item.posseduto_da[0] &&
                item.posseduto_da[0].valore && (
                  <Chip
                    className={classes.chip}
                    label={`€ ${item.posseduto_da[0].valore}`}
                  />
                )}

              {!isUndefined(iWant) &&
                !isUndefined(iWantNot) &&
                !item.posseduto && (
                  <WantedHeart
                    wanted={item.voluto}
                    loading={wantedLoading}
                    iWant={() => iWant(item)}
                    iWantNot={() => iWantNot(item)}
                  />
                )}
            </div>
          </Typography>
        </CardContent>

        {item.posseduto_da &&
          item.posseduto_da[0] && (
            <div className={classes.cardOwner}>
              <div>
                <div>
                  <Icon className={classes.iconStylesRel} color="action">
                    person
                  </Icon>
                  di{' '}
                  <Link
                    onClick={stopClick}
                    className={classes.userLinkStyle}
                    to={`/user/${item.posseduto_da[0].user.username}`}>
                    <strong>
                      {item.posseduto_da[0].user.username ||
                        item.posseduto_da[0].user.nome}
                    </strong>
                  </Link>
                </div>
              </div>
              <div className={classes.flexContainer}>
                <div className={classes.place}>
                  <Icon className={classes.iconStylesRel} color="action">
                    place
                  </Icon>
                  <p className={classes.placeText}>
                    {truncate(item.posseduto_da[0].user.provincia, {
                      length: 17,
                      omission: '...',
                    })}
                  </p>
                </div>
                <div className={classes.centerIconContainer}>
                  {item.posseduto_da[0].user.transazioni > 3 && (
                    <Icon className={classes.iconStyles} color="action">
                      {AFFIDABILITA_ICON_NAME}
                    </Icon>
                  )}
                  {item.posseduto_da[0].user.transazioni > 3 && (
                    <p className={classes.tradesInfo}>
                      {Number(
                        item.posseduto_da[0].user.affidabilita * 100
                      ).toFixed()}
                      %
                    </p>
                  )}
                </div>
                <div className={classes.rightIconContainer}>
                  <Icon className={classes.iconStyles} color="action">
                    cached
                  </Icon>
                  <p className={classes.tradesInfo}>
                    {item.posseduto_da[0].user.transazioni}
                  </p>
                </div>
              </div>
            </div>
          )}
      </Card>
    )
  }
}

const byChiave = defaultMemoize(attrs => keyBy(attrs, 'chiave'))

const mapStateToProps = (state, ownProps) => {
  const category = getCategory(state, get(ownProps, 'item.categoria.slug'))
  const filterAttributes = category
    ? byChiave(getFilterAttributesByCategory(category))
    : null
  return {
    filterAttributes,
  }
}
export default withStyles(styles)(connect(mapStateToProps)(ObjectCard))



// WEBPACK FOOTER //
// ./src/common/ObjectCard.js